import React from "react";
import * as Icon from "../../../../../assets/iconsSVG";
import * as Styles from "./styles";

interface Props {
  onClose: () => void;
}
const Header: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Styles.RowSpace>
        <Styles.Row>
          <Styles.Title>Vincular Ficha</Styles.Title>
        </Styles.Row>
        <Styles.Button onClick={() => props?.onClose()}>
          <Icon.CloseIcon />
        </Styles.Button>
      </Styles.RowSpace>
    </Styles.Container>
  );
};

export default Header;
